export interface ExecutionContext {
    isRunning: boolean;
    isPaused: boolean;
    ignoreBreakpoints: boolean;
    currentStep: number;

    addLog: (msg: string) => void;
    stop: () => void;
    nextStep: () => void;
}

/** Contexte par défaut (agnostique) */
export function createDefaultExecutionContext(logCallback: (msg: string) => void): ExecutionContext {
    const ctx: ExecutionContext = {
        isRunning: false,
        isPaused: false,
        ignoreBreakpoints: false,
        currentStep: 0,

        addLog: (msg: string) => { logCallback(msg); },
        stop() { this.isRunning = false; },
        nextStep() { this.currentStep++; },
    };
    return ctx;
}
